import React, { useState } from 'react';
import { ToggleButton, ToggleButtonGroup, Box } from '@mui/material';
import { BarChart as BarChartIcon, TableChart as TableChartIcon } from '@mui/icons-material';
import PopulationGrowthChart from './PopulationGrowthChart';
import PopulationShareChart from './PopulationShareChart';
import PopulationGrowthTable from './PopulationGrowthTable';
import PopulationShareTable from './PopulationShareTable';
import { ChartsContainer } from './style';

const PopulationCharts = ({ growthData, shareData, growthTitle, shareTitle, locationNames }) => {
    const [viewMode, setViewMode] = useState('chart');

    const handleViewModeChange = (event, newMode) => {
        if (newMode !== null) {
            setViewMode(newMode);
        }
    };

    return (
        <ChartsContainer>
            {/* Toggle Button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <ToggleButtonGroup
                    value={viewMode}
                    exclusive
                    onChange={handleViewModeChange}
                    aria-label="view mode"
                    size="small"
                >
                    <ToggleButton value="chart" aria-label="chart view">
                        <BarChartIcon sx={{ mr: 1 }} />
                        차트
                    </ToggleButton>
                    <ToggleButton value="table" aria-label="table view">
                        <TableChartIcon sx={{ mr: 1 }} />
                        테이블
                    </ToggleButton>
                </ToggleButtonGroup>
            </Box>

            {/* Chart View */}
            {viewMode === 'chart' && (
                <>
                    {growthData && growthTitle && <PopulationGrowthChart data={growthData} title={growthTitle} />}
                    {shareData && shareTitle && (
                        <PopulationShareChart data={shareData} title={shareTitle} locationNames={locationNames} />
                    )}
                </>
            )}

            {/* Table View */}
            {viewMode === 'table' && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    {growthData && growthTitle && <PopulationGrowthTable data={growthData} title={growthTitle} />}
                    {shareData && shareTitle && (
                        <PopulationShareTable data={shareData} title={shareTitle} locationNames={locationNames} />
                    )}
                </Box>
            )}
        </ChartsContainer>
    );
};

export default PopulationCharts;
